import axios from 'axios';
import moment from 'moment';
import _ from 'lodash';
import buildStr from "./strbuilder";
import store from "@/store";

export default {
  async getMainDeliveries(addressId) {
    if (!addressId) return [];
    const response = await axios.get(`/api/Address/${addressId}/MainDelivery`);
    return response.data;
  },
  async getSmallDeliveries(addressId) {
    if (!addressId) return [];
    const response = await axios.get(`/api/Address/${addressId}/SmallDelivery`);
    return response.data;
  },
  async getContacts(addressId) {
    if (!addressId) return [];
    const response = await axios.get(`/api/Address/${addressId}/Contact`);
    return response.data;
  },
  async getAllContacts() {
    const response = await axios.get(`/api/Contact`);
    return response.data;
  },

  async getOffers(addressId) {
    if (!addressId) return [];
    const response = await axios.get(`/api/Address/${addressId}/Offer`);
    const offers = response.data.map(offer => {
      const copy = Object.assign({}, offer);
      copy.expirationDate = moment(offer.expirationDate);
      return copy;
    });
    return offers;
  },
  async getOffer(offerId, addressId) {
    if (!addressId) return [];
    const response = await axios.get(`/api/Address/${addressId}/Offer`);
    const offers = response.data.map(offer => {
      const copy = Object.assign({}, offer);
      copy.expirationDate = moment(offer.expirationDate);
      return copy;
    });
    return offers.filter(o => o.id === offerId);
  },
  async getOfferDocuments(offerId) {
    const response = await axios.get(`/api/Offer/${offerId}/Document`);
    return response.data;
  },
  async getOffer3dModels(offerId) {
    const response = await axios.get(`/api/Offer/${offerId}/Showroom`);
    return response.data;
  },
  async getAddressDocuments(addressId) {
    const response = await axios.get(`/api/Address/${addressId}/Document`);
    return response.data;
  },
  async getAllDocuments() {
    const response = await axios.get(`/api/Document`);
    return response.data;
  },
  async addDocument(data) {
    const response = await axios.post('/api/Document', data);
    return response.data;
  },
  async getAddresses() {
    const response = await axios.get(`/api/User/Address`);
    const addresses = response.data;
    return addresses;
  },
  async acceptInvitation(invitationId) {
    const response = await axios.get(`/api/Invitation/${invitationId}`);
    return response.data;
  },
  /**
   *
   * @param userId
   * @param {!Object} updateData
   * @param {!string} updateData.language,
   * @param {!boolean} updateData.pushNotificationsEnabled,
   * @returns {Promise<any>}
   */
  async updateUser(userId, updateData) {
    if (!('language' in updateData) || !('pushNotificationsEnabled' in updateData)) {
      console.log('invalid data');
      return;
    }

    const data = {
      language: updateData.language,
      pushNotificationsEnabled: updateData.pushNotificationsEnabled,
    };
    const response = await axios.post(`/api/User`, data);
    return response.data;
  },

  async getNotifications(addressId) {
    const response = await axios.get(`/api/Address/${addressId}/Notification`);
    const notifications = response.data;
    return _.orderBy(notifications, ['createdAt'], ['desc'])
  },
  async openNotification(notificationId) {
    const response = await axios.get(`/api/Notification/${notificationId}`);
    return response.data;
  },
  async getRegistrationLinks() {
    const response = await axios.get('/api/Contact/Registrations');
    return response.data;
  },
  async getInvoiceRows(invoiceId) {
    const response = await axios.get(`/api/Invoice/${invoiceId}/Rows`);
    return response.data;
  },
  async validateImpersonateToken(token) {
    const response = await axios.get(`/api/Impersonate/${token}`)
    return response.data;
  },
  async endImpersonation() {
    const response = await axios.delete(`/api/Impersonate`)
    return response.data;
  },
  async debug(debugData) {
    const url = '/api/System/debug';
    const response = await axios.post(url, debugData);
    return response.data;
  },
}
